import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";

import { Category } from "../categories/Category";
import { routes } from "../../common/routing/routes";
import { TicketType } from "../ticketType/TicketType";
import { GenericSettingsApiKey } from "../systemSettings/SystemSettings";
import { fetchSystemSettingByKey } from "../systemSettings/systemSettingsApi";
import TicketClassifier from "../tickets/TicketClassifier";
import UserTicketsCard from "../tickets/UserTicketsCard";
import ServiceCatalogCards from "../serviceCatalog/ServiceCatalogCards";

export default function DashboardPage() {
  const navigate = useNavigate();
  const [isCategoryAiSearchEnabled, setIsCategoryAiSearchEnabled] = useState<boolean>();

  useEffect(() => {
    const doFetchSystemSettingByKey = async () => {
      const categoryAiSearchEnabled = await fetchSystemSettingByKey(GenericSettingsApiKey.CategoryAiSearchEnabled);
      setIsCategoryAiSearchEnabled(JSON.parse(categoryAiSearchEnabled.value));
    };
    doFetchSystemSettingByKey();
  }, []);

  const handleCategorySelect = (category: Category, searchText: string) => {
    const encodedSearchText = encodeURIComponent(searchText);
    const navigationUrl =
      category.ticketType === TicketType.Incident
        ? `${routes.createIncident.path}?departmentId=${category.departmentId}&categoryId=${category.id}&searchText=${encodedSearchText}`
        : `${routes.createRequest.path}?departmentId=${category.departmentId}&categoryId=${category.id}&searchText=${encodedSearchText}`;

    navigate(navigationUrl);
  };

  return (
    <div className="grid">
      {isCategoryAiSearchEnabled ? (
        <div className="col-12">
          <Card title="Deschide un tichet nou">
            <TicketClassifier showAlternativeCategories={true} onCategorySelect={handleCategorySelect} />
          </Card>
        </div>
      ) : (
        <ServiceCatalogCards className="col-12" />
      )}
      <div className="col-12">
        <UserTicketsCard></UserTicketsCard>
      </div>
    </div>
  );
}
